import { SvgProps } from "components/icons/types";

export const GridFour = (props: SvgProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_grid_four)">
      <path
        d="M8.41667 8.41667H2V3.75C2 3.28587 2.18437 2.84075 2.51256 2.51256C2.84075 2.18437 3.28587 2 3.75 2H8.41667V8.41667ZM3.16667 7.25H7.25V3.16667H3.75C3.59529 3.16667 3.44692 3.22812 3.33752 3.33752C3.22812 3.44692 3.16667 3.59529 3.16667 3.75V7.25Z"
        fill="currentColor"
      />
      <path
        d="M15.9999 8.41667H9.58325V2H14.2499C14.714 2 15.1592 2.18437 15.4873 2.51256C15.8155 2.84075 15.9999 3.28587 15.9999 3.75V8.41667ZM10.7499 7.25H14.8332V3.75C14.8332 3.59529 14.7718 3.44692 14.6624 3.33752C14.553 3.22812 14.4046 3.16667 14.2499 3.16667H10.7499V7.25Z"
        fill="currentColor"
      />
      <path
        d="M8.41667 15.9999H3.75C3.28587 15.9999 2.84075 15.8155 2.51256 15.4873C2.18437 15.1592 2 14.714 2 14.2499V9.58325H8.41667V15.9999ZM3.16667 10.7499V14.2499C3.16667 14.4046 3.22812 14.553 3.33752 14.6624C3.44692 14.7718 3.59529 14.8332 3.75 14.8332H7.25V10.7499H3.16667Z"
        fill="currentColor"
      />
      <path
        d="M14.2499 15.9999H9.58325V9.58325H15.9999V14.2499C15.9999 14.714 15.8155 15.1592 15.4873 15.4873C15.1592 15.8155 14.714 15.9999 14.2499 15.9999ZM10.7499 14.8332H14.2499C14.4046 14.8332 14.553 14.7718 14.6624 14.6624C14.7718 14.553 14.8332 14.4046 14.8332 14.2499V10.7499H10.7499V14.8332Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_grid_four">
        <rect width="14" height="14" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
